import axios from 'axios'
import * as HttpStatus from 'http-status-codes'
import { Identifier } from 'react-admin'

import { detectEnvironment, Environment } from '../config/config'
import { getVGSUrl } from '../helpers/utils'

export async function getInviteToSendbirdIssueChat(issueId: Identifier, issueClass: string) {
  // get invited to the Sendbird chat for the issue, if not already a member
  let url = ''
  if (issueClass === 'JOB') {
    url = `/api/v1/console/issues/${issueId}/chat/`
  } else if (issueClass === 'LOAD') {
    url = `/api/v1/console/load-issues/${issueId}/chat/`
  } else if (issueClass === 'GENERIC') {
    url = `/api/v1/console/generic-issues/${issueId}/chat/`
  } else {
    throw new Error('Invalid issue class')
  }
  const response = await axios.post(url)
  return response.status === HttpStatus.OK
}

export async function getAccessToken(userId: string) {
  const url = `${getVGSUrl()}/api/v3/users/${userId}/sendbird/reveal/`
  const withCredentials = detectEnvironment() === Environment.DEVELOPMENT ? false : true
  const response = await axios.post(url, null, { withCredentials })
  if (response.status === HttpStatus.OK) {
    return response.data.access_token_encrypted
  } else {
    return null
  }
}
